/* eslint-disable max-len, max-lines */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable max-lines, quotes, react/destructuring-assignment */

import {fetchCustomerCredits, fetchCustomerRequests, fetchPDPrices, setOffset} from "../../../actions/index";
import {requestsNeededTotal, wishlistCacheLifespan} from "../../../lib/CONSTANTS";
import API from "../../../shared/modules/API";
import AnalyticsHelper from "../../../shared/modules/AnalyticsHelper";
import FiltersContainer from "./FiltersContainer";
import {Helmet} from "react-helmet";
import Helper from "../../../shared/modules/Helper";
import Notification from "../../../shared/components/Notification";
import ProductDetailsModal from "./ProductDetailsModal";
import PropTypes from "prop-types";
import React from "react";
import RemovedHoldBanner from "./RemovedHoldBanner";
import SearchResultsBanner from "../../Search/SearchResultsBanner";
import Spinner from "../../../shared/components/Spinner";
import WishlistGrid from "./WishlistGrid";
import WishlistMoreBanner from "../../../shared/components/WishlistMoreBanner";
import _filter from "lodash/filter";
import {connect} from "react-redux";

class Wishlist extends React.Component {

  static propTypes = {
    "addWishListRequest": PropTypes.func.isRequired,
    "analyticsProps": PropTypes.object.isRequired,
    "bannerClass": PropTypes.string,
    "bannerUrl": PropTypes.string,
    "categories": PropTypes.array.isRequired,
    "collectFilters": PropTypes.func.isRequired,
    "customerCredits": PropTypes.object.isRequired,
    "customerRequests": PropTypes.object.isRequired,
    "customerState": PropTypes.string,
    "designers": PropTypes.array.isRequired,
    "eligibleForFineJewelry": PropTypes.bool,
    "event": PropTypes.object,
    "excludeTrendsFromFilter": PropTypes.bool,
    "fetchNewProps": PropTypes.func.isRequired,
    "fetchPDPrices": PropTypes.func.isRequired,
    "filters": PropTypes.array.isRequired,
    "fromReactivation": PropTypes.bool.isRequired,
    "fromSignup": PropTypes.bool.isRequired,
    "handleCloseProductDetailsModal": PropTypes.func.isRequired,
    "handleOpenProductDetailsModal": PropTypes.func.isRequired,
    "lastScrollPosition": PropTypes.number,
    "lessThanOneDayOld": PropTypes.bool,
    "modalOpen": PropTypes.bool.isRequired,
    "nonMemberCartEnabled": PropTypes.bool.isRequired,
    "notificationDisplayIconClass": PropTypes.string,
    "notificationDisplayText": PropTypes.string,
    "offset": PropTypes.number.isRequired,
    "params": PropTypes.object.isRequired,
    "pdPrices": PropTypes.object.isRequired,
    "productOrdering": PropTypes.array.isRequired,
    "productPanelClass": PropTypes.string,
    "products": PropTypes.object.isRequired,
    "propsCache": PropTypes.object.isRequired,
    "removeWishListRequest": PropTypes.func.isRequired,
    "requestsFetched": PropTypes.bool.isRequired,
    "scrollPosition": PropTypes.number,
    "selectedFilters": PropTypes.array,
    "setOffset": PropTypes.func.isRequired,
    "showClearancePrice": PropTypes.bool,
    "showComingSoon": PropTypes.bool,
    "showPriceRangeFilters": PropTypes.bool,
    "showProductName": PropTypes.bool,
    "showPromoFilters": PropTypes.bool,
    "showRetailPrice": PropTypes.bool,
    "showTags": PropTypes.bool,
    "showTrendFilters": PropTypes.bool,
    "showWishlistStars": PropTypes.bool,
    "sorts": PropTypes.array.isRequired,
    "stickyFilter": PropTypes.object,
    "title": PropTypes.string.isRequired,
    "updateLastScrollPosition": PropTypes.func.isRequired,
    "updateState": PropTypes.func.isRequired,
    "useModal": PropTypes.bool
  };

  static defaultProps = {
    "analyticsProps": {},
    "bannerClass": "wish-list-leader-panel",
    "bannerUrl": null,
    "customerCredits": {
      "shine": 0,
      "shopping": 0
    },
    "customerRequests": {},
    "customerState": "",
    "eligibleForFineJewelry": false,
    "event": null,
    "excludeTrendsFromFilter": false,
    "fromSignup": false,
    "lastScrollPosition": 0,
    "lessThanOneDayOld": false,
    "notificationDisplayIconClass": "",
    "notificationDisplayText": "",
    "offset": 36,
    "pdPrices": {},
    "productPanelClass": "",
    "products": {},
    "requestsFetched": false,
    "scrollPosition": 0,
    "selectedFilters": [],
    "showClearancePrice": false,
    "showComingSoon": false,
    "showPriceRangeFilters": false,
    "showProductName": false,
    "showPromoFilters": false,
    "showRetailPrice": false,
    "showTags": false,
    "showTrendFilters": false,
    "showWishlistStars": false,
    "stickyFilter": {},
    "useModal": false
  };

  constructor (props) {
    super(props);
    const {notificationDisplayText} = this.props;
    this.state = {
      "confirmModalOpen": new URL(window.location.href).searchParams.get('veto_complete'),
      "didSetup": false,
      "filtering": false,
      "latestRequest": null,
      "lazyLoadingNow": false,
      "modalProductDescriptorId": null,
      "noMoreToLoad": false,
      "notificationText": notificationDisplayText,
      "notificationType": "",
      "searchParam": new URL(window.location.href).searchParams.get('search')
    };
  }

  componentDidMount () {
    const {fetchNewProps} = this.props;
    if (this.isReady()) {
      this.onReady();
    } else {
      fetchNewProps(window.location.pathname);
    }
    this.fetchWishlistPrices();
    this.fireBecameMemberEvent();
  }

  componentDidUpdate = () => {
    if (!this.state.didSetup && this.isReady()) {
      this.onReady();
    }
    if (this.state.searchParam !== new URL(window.location.href).searchParams.get('search')) {
      this.setState({"searchParam": new URL(window.location.href).searchParams.get('search')});
    }
  }

  componentWillUnmount = () => {
    removeEventListener("scroll", this.onScroll, false);
  }

  isMobile = window.innerWidth <= 767;

  fetchWishlistPrices = () => {
    const {fetchPDPrices, pdPrices, productOrdering} = this.props; // eslint-disable-line no-shadow

    if (API.CUSTOMER_ID) {
      const needPricePids = productOrdering.filter(pid => !pdPrices || !pdPrices[pid]);
      if (needPricePids.length > 0) {
        fetchPDPrices(needPricePids);
      }
    }
  }

  isReady () {
    const cachedProps = this.props.propsCache[window.location.pathname];
    if (!cachedProps || typeof cachedProps.createdAt !== "number") {
      return false;
    }
    const cacheAge = Date.now() - cachedProps.createdAt; // eslint-disable-line one-var
    return cacheAge < wishlistCacheLifespan;
  }

  onReady = () => {
    this.forceScroll(this.props.lastScrollPosition);

    addEventListener("scroll", this.onScroll, false);

    this.setState({"didSetup": true});
  };

  forceScroll = (scrollPosition) => {
    $(window).scrollTop(scrollPosition);
  }

  onScroll = () => {
    const {"params": {action, controller}, offset} = this.props;
    const {lazyLoadingNow, noMoreToLoad} = this.state;
    const endpoint = `/${controller.split("/").pop()}${
      [
        "index",
        "add"
      ].includes(action)
        ? ""
        : `/${action}`}`;

    if ([
      '/jewelry',
      '/shop',
      '/shop/clearance'
    ].includes(window.location.pathname)) {
      this.props.updateLastScrollPosition($(window).scrollTop());
    }

    if (lazyLoadingNow || noMoreToLoad ||
      $(window).scrollTop() + $(window).height() <= $(document).height() - 1000) {
      return;
    }
    this.fetchWishlist(offset, endpoint, false);
  }

  fetchWishlist = (newOffset, action, onFilter) => {
    const {collectFilters, offset, setOffset} = this.props; // eslint-disable-line
    const {searchParam} = this.state; // eslint-disable-line
    const filters = collectFilters();
    const id = Number(new Date());
    this.setState({
      "filtering": onFilter,
      "latestRequest": id,
      "lazyLoadingNow": true
    }, () => API.fetchWishlist(newOffset, action, filters, searchParam).then((response) => {
      if (this.state.latestRequest !== id) return;
      this.props.updateState(prevState => ({
        "products": Helper.createProductObject(response.products, prevState.products),
        "wishlist": {
          ...prevState.wishlist,
          "productOrdering": onFilter
            ? response.products.map(product => product.id)
            : [
              ...prevState.wishlist.productOrdering,
              ...response.products.map(product => product.id)
            ]
        }
      }), () => {

        /*
         *  After the new pieces have been fetched
         *  1. fetch member and clearance prices
         *  2. Set the new offset (total number of pieces) in redux
         *  3. Update state of component
         */

        this.fetchWishlistPrices();
        if (onFilter && offset !== 36) {
          setOffset(36);
        } else if (!onFilter) {
          setOffset(offset + 36);
        }
        this.setState({
          "filtering": false,
          "lazyLoadingNow": false,
          "noMoreToLoad": response.products.length !== 36
        });
      });
    }));
  }

  fromBINPurchase = () => {
    const {selectedFilters} = this.props;

    return selectedFilters.length === 1 && selectedFilters[0].displayName === 'Shop Now';
  }

  filter = () => {
    const {"params": {action, controller}} = this.props;
    const endpoint = `/${controller.split("/").pop()}${
      [
        "index",
        "add"
      ].includes(action)
        ? ""
        : `/${action}`}`;

    if (!this.isMobile && !this.fromBINPurchase()) {
      this.forceScroll(275);
      this.props.updateLastScrollPosition(275);
    }
    this.fetchWishlist(0, endpoint, true);
  }

  showModal = (id) => {
    const {handleOpenProductDetailsModal} = this.props;

    this.setState({"modalProductDescriptorId": id});
    handleOpenProductDetailsModal();
  }

  hideModal = () => {
    const {handleCloseProductDetailsModal} = this.props;

    this.setState({"modalProductDescriptorId": null});
    handleCloseProductDetailsModal();
  }

  updateModalProductDescriptor = (id) => {
    const {"products": {[id]: product}} = this.props;

    if (product) {
      this.setState({"modalProductDescriptorId": id});
    } else {
      API.fetchProducts(null, {id}).then(response => this.props.updateState(prevState =>
        ({"products": Helper.createProductObject([response.products], prevState.products)}), () => {
        this.setState({"modalProductDescriptorId": id});
      }));
    }
  };

  setNotificationText = (text) => {
    this.setState({"notificationText": text});
  }

  setNotificationType = (value) => {
    this.setState({"notificationType": value});
  }

  bannerContent = () => {
    const {
      bannerClass,
      bannerUrl,
      customerState
    } = this.props;

    const {searchParam} = this.state;

    return (
      <a href={bannerUrl}>
        <div className={`${customerState} secondary-leader-panel ${bannerClass} ${searchParam && searchParam.length > 0 ? 'hidden' : ''}`}>
          <img className="sr-only" />
        </div>
      </a>
    );
  };

  fireBecameMemberEvent = () => {
    const {
      fromReactivation,
      fromSignup,
      analyticsProps
    } = this.props;
    const {customerId} = analyticsProps;

    if (fromSignup && !fromReactivation) {
      AnalyticsHelper.sendBecameMemberFrontendAndSubscribeEvent(customerId, analyticsProps);
    }
  };

  removedHold = () => {
    const path = window.location.href;
    const url = new URL(path);
    const params = new URLSearchParams(url.search.slice(1));
    return params.has("removed_hold");
  }

  render () {
    const {
      addWishListRequest,
      categories,
      collectFilters,
      customerRequests,
      customerState,
      eligibleForFineJewelry,
      excludeTrendsFromFilter,
      designers,
      filters,
      lessThanOneDayOld,
      modalOpen,
      nonMemberCartEnabled,
      notificationDisplayIconClass,
      params,
      productOrdering,
      productPanelClass,
      products,
      removeWishListRequest,
      requestsFetched,
      showClearancePrice,
      showComingSoon,
      showProductName,
      showPriceRangeFilters,
      showPromoFilters,
      showRetailPrice,
      showTags,
      showTrendFilters,
      showWishlistStars,
      sorts,
      stickyFilter,
      title,
      updateState,
      useModal
    } = this.props;
    const {filtering, searchParam, lazyLoadingNow, confirmModalOpen, modalProductDescriptorId, notificationText, notificationType} = this.state;
    const {[modalProductDescriptorId]: modalProductDescriptor} = products;
    const requestsNeeded = requestsFetched
      ? requestsNeededTotal - _filter(customerRequests, req => req.statuses.includes("pending")).length
      : 0;

    if (!this.isReady()) {
      return (
        <Spinner
          className="spinner"
        />
      );
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {title}
          </title>
        </Helmet>
        <h1 className="hidden">
          Shop Rocksbox Jewelry
        </h1>
        <div className="container-fluid no-padding filter-container">
          {this.removedHold()
            ? <RemovedHoldBanner />
            : <WishlistMoreBanner
              confirmModalOpen={confirmModalOpen}
              display={productPanelClass === "wishlist-page" && customerState === "logged-in"}
              lessThanOneDayOld={lessThanOneDayOld}
              requestsNeeded={requestsNeeded}
            />
          }
          {this.bannerContent()}
          {searchParam && <SearchResultsBanner searchParam={searchParam} />}
          <FiltersContainer
            categories={categories}
            collectFilters={collectFilters}
            customerState={customerState}
            designers={designers}
            doFilter={this.filter}
            eligibleForFineJewelry={eligibleForFineJewelry}
            excludeTrendsFromFilter={excludeTrendsFromFilter}
            filters={filters}
            isMobile={this.isMobile}
            params={params}
            productPanelClass={productPanelClass}
            requestsNeeded={requestsNeeded}
            showClearancePrice={showClearancePrice}
            showPriceRangeFilters={showPriceRangeFilters}
            showPromoFilters={showPromoFilters}
            showTrendFilters={showTrendFilters}
            sorts={sorts}
            stickyFilter={stickyFilter}
          />
          {useModal && modalProductDescriptor &&
          <ProductDetailsModal
            addWishListCallback={addWishListRequest}
            eligibleForFineJewelry={eligibleForFineJewelry}
            nonMemberCartEnabled={nonMemberCartEnabled}
            onCloseModal={this.hideModal}
            open={modalOpen}
            product={modalProductDescriptor}
            removeWishListCallback={removeWishListRequest}
            showClearancePrice={showClearancePrice}
            updateModalProductDescriptor={this.updateModalProductDescriptor}
          />}
          <WishlistGrid
            addWishListRequest={addWishListRequest}
            allRingSizes={filters.find(filter => filter.key === "size").selections.map(selection => selection.name)}
            eligibleForFineJewelry={eligibleForFineJewelry}
            filtering={filtering}
            hideModal={this.hideModal}
            lazyLoadingNow={lazyLoadingNow}
            productOrdering={productOrdering}
            productPanelClass={productPanelClass}
            products={products}
            removeWishListRequest={removeWishListRequest}
            requestsFetched={requestsFetched}
            setNotificationType={this.setNotificationType}
            showClearancePrice={showClearancePrice}
            showComingSoon={showComingSoon}
            showModal={this.showModal}
            showProductName={showProductName}
            showPromoPrice={showPromoFilters}
            showRetailPrice={showRetailPrice}
            showTags={showTags}
            showWishlistStars={showWishlistStars}
            updateState={updateState}
            useModal={useModal}
          />
          {notificationType &&
          <Notification
            notificationDisplayType={notificationType}
            setNotificationDisplayType={this.setNotificationType}
          />}
          {notificationText &&
            <Notification
              notificationDisplayIconClass={notificationDisplayIconClass}
              notificationDisplayText={notificationText}
              setNotificationDisplayText={this.setNotificationText}
            />
          }
        </div>
      </React.Fragment>
    );
  }
}

const mapStoreToProps = store =>
  ({
    "customerCredits": store.customerCredits,
    "customerRequests": store.customerRequests,
    "offset": store.offset,
    "pdPrices": store.pdPrices,
    "selectedFilters": store.selectedFilters || []
  });

export default connect(
  mapStoreToProps,
  {
    fetchCustomerCredits,
    fetchCustomerRequests,
    fetchPDPrices,
    setOffset
  }
)(Wishlist);
